<template>
    <div class="mb-4 bg-light-gray">
        <div class="col-12 py-5 px-5">
            <div class="row ">
                <div class="col-md-12 mb-2">
                    <v-select class="mb-2 select-bg--gray" v-model="form.location" :options="data.locations" placeholder="Type your search location" />
                </div>
                <div class="col-md-6 mb-2">
                    <select class="form-control custom-select custom-select--white mb-2" v-model="form.propertyType">
                        <option value="0">Property Type</option>
                        <option v-for="type in data.propertyTypes" :key="type.id" :value="type.id">{{ type.name }}</option>
                    </select>
                </div>
                <div class="col-md-6 mb-2">
                    <select class="form-control custom-select custom-select--white mb-2" v-model="form.beds">
                        <option value="0">Beds</option>
                        <option v-for="bed in data.beds" :key="bed" :value="bed">{{ bed }}</option>
                    </select>
                </div>
                <div class="col-md-6 mb-2">
                    <select class="form-control custom-select custom-select--white mb-2" v-model="form.minPrice">
                        <option value="0">Min Price</option>
                        <option v-for="n in data.minPrices.length" :key="n" :value="data.basePrices[(n - 1)]">{{ renderCurrency(data.minPrices[(n - 1)]) }}</option>
                    </select>
                </div>
                <div class="col-md-6 mb-2">
                    <select class="form-control custom-select custom-select--white mb-2" v-model="form.maxPrice">
                        <option value="0">Max Price</option>
                        <option v-for="n in data.maxPrices.length" :key="n" :value="data.basePrices[(n - 1)]">{{ renderCurrency(data.maxPrices[(n - 1)]) }}</option>
                    </select>
                </div>
                <div class="col-md-12 mt-2">
                    <button type="submit" class="btn btn-green" @click="updateLivewire">{{ form.id == 0 ? "Create" : "Edit" }} Alert</button>
                    <!--                    <button class="btn btn-green" @click.prevent="resetForm">Reset</button>-->
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import {formatForCurrency, } from '../Helpers';

export default {
    name: 'member-property-alert-form',
    data() {
        return {
            data: {
                locations: [],
                propertyTypes: [],
                beds: [],
                minPrices: [],
                maxPrices: []
            },
            form: {
                id: 0,
                location: '',
                propertyType: 0,
                beds: 0,
                minPrice: 0,
                maxPrice: 0
            }
        };
    },
    created() {
        this.data.propertyTypes = window.Propuno.property_types;
        //this.data.locations = window.Propuno.locations;
        this.data.minPrices = window.Propuno.sale_prices;
        this.data.maxPrices = window.Propuno.sale_prices;
        this.data.beds = window.Propuno.beds;
        this.data.basePrices = window.Propuno.sale_base_prices;

        var locations = window.Propuno.countries;
        locations = locations.concat(window.Propuno.cities);
        locations = locations.concat(window.Propuno.towns);
        this.data.locations = locations.filter(function(item, pos) {
            return locations.indexOf(item) == pos;
        });

        window.addEventListener('livewireSuccess', event => {
            this.resetForm();
        });

        window.addEventListener('alertEdit', event => {
            this.form = {
                id: event.detail.id,
                location: event.detail.in,
                propertyType: event.detail.property_type_id,
                beds: event.detail.beds,
                minPrice: event.detail.price_from,
                maxPrice: event.detail.price_to
            };

            window.scroll({
                top: 0,
                left: 0,
                behavior: 'smooth'
            });
        });
    },
    methods: {
        renderCurrency(val) {
            return formatForCurrency(val);
        },
        resetForm() {
            this.form = {
                id: 0,
                location: '',
                propertyType: 0,
                beds: 0,
                minPrice: 0,
                maxPrice: 0
            };
        },
        updateLivewire: function() {
            window.Livewire.emit('formSubmitted', {
                'id': this.form.id,
                'location': this.form.location,
                'type': this.form.propertyType,
                'beds': this.form.beds,
                'minPrice': this.form.minPrice,
                'maxPrice': this.form.maxPrice
            });
        }
    }
}
</script>
